<template>
  <div>
    <self-back :pageHeaderList="[{'name':'成本税点比例配置'}]"></self-back>
    <div class="content" v-loading='loading'>
      <div class="clear topBox">
        <div class="left">
          <button class="addaccountButton" @click="addaccountEvent">+ 添加成本税点比例</button>
          <el-date-picker style="width:160px;margin-left:10px;" v-model="screenMonth" :clearable='false' type="month" size="mini" value-format="yyyy-MM" placeholder="月份筛选">
          </el-date-picker>
          <button class="addaccountButton" style="margin-left:10px;" @click="exportEvent">导出</button>
          
        </div>
      </div>
      <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="customerList" :max-height="tableMaxHeight" border>
        <el-table-column prop="month" label="月份" align='center'></el-table-column>
        <el-table-column prop="cost_company_name" label="成本公司全称" align='center'></el-table-column>
        <el-table-column prop="rate" label="成本税点比例" align='center'></el-table-column>
        <el-table-column label="开票日期" align='left' width='300'>
          <template slot-scope="scope">
            <p v-for="(item,index) in scope.row.cost_invoice_arr" :key="index">{{index}}：{{item}}</p>
          </template>
        </el-table-column>
        <el-table-column align='center' width='160' label="操作">
          <template slot-scope="scope">
            <button @click="setCostInvoice(scope.row)">申请成本开票</button>
            <button @click="updateEvent(scope.row)">修改</button>
            <button style="background:#FC726D" @click="deleteaccountFlagEvent(scope.row)">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationBox" style="height: 30px;">
        <el-pagination small background @current-change="handleCurrentChange" :current-page="page" :page-size="page_size" layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 添加账号 -->
    <el-dialog :title="isEdit?'修改成本税点比例':'添加成本税点比例'" :visible.sync="addaccountFlag" width="30%" :close-on-click-modal='false' center>
      <div class="dialogBox" v-loading='loading'>
        <div class="dialogitem">
          <label><em>*</em>成本公司全称：</label>
          <el-select class="input" v-model="cost_company_name" size='mini' filterable placeholder="请选择成本公司全称">
            <el-option v-for="(item,index) in costCompanysList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="dialogitem">
          <label><em>*</em>税点比例：</label>
          <el-input placeholder="请输入税点比例" style="width:40%" v-model.trim="rate" @input="(val)=>{rate=rate.replace(/[^\d|.]/g,'')}" size='small' clearable>
          </el-input>
          <span>(例：1.07)</span>
        </div>
        <div class="dialogitem">
          <label><em>*</em>时间：</label>
          <el-date-picker style="width:56%" v-model="timeMonth" type="month" size="mini" value-format="yyyy-MM" placeholder="选择时间">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
        <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 申请成本开票日期 -->
    <el-drawer title="申请成本开票" :visible.sync="costInvoiceFlag" direction="ltr" :size='800' :before-close="handleClose">
      <div class="drawer-container" v-loading='orderLoading'>
        <div>
          <div class="flex-between">
            <div class="dialogitem flex">
              <label>成本公司全称：</label>
              <div class="input">{{costInvoiceInfo.cost_company_name}}</div>
            </div>
            <div class="dialogitem flex">
              <label>月份：</label>
              <div class="input">{{costInvoiceInfo.month}}</div>
            </div>
          </div>
          <div class="flex-between">
            <div class="dialogitem">
              <label><em>*</em>开票日期：</label>
              <el-date-picker class="input" v-model="cost_invoice_date" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="选择时间" @change="orderChange">
              </el-date-picker>
            </div>
            <div class="dialogitem">
              <label><em>*</em>签约公司：</label>
              <el-select class="input" v-model="company" size='mini' filterable placeholder="请选择签约公司" @change="orderChange($event);handleGetMediaNameOptions();">
                <el-option v-for="(item,index) in signCompanyList" :key="index" :label="item.company" :value="item.company">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="flex-between">
            <div class="dialogitem">
              <label>授信/现金：</label>
              <el-select class="input" v-model="is_cash" clearable size='mini' filterable placeholder="请选择授信/现金" @change="orderChange($event);handleGetMediaNameOptions();">
                <el-option label="现金" :value="1"></el-option>
                <el-option label="授信" :value="2"></el-option>
              </el-select>
            </div>
            <div class="dialogitem">
              <label>项目名称：</label>
              <el-select class="input" v-model="project_name" size='mini' clearable filterable placeholder="请选择项目名称" @change="orderChange($event);handleGetMediaNameOptions();">
                <el-option v-for="(item,index) in projectList" :key="index" :label="item.title" :value="item.title">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="flex-between">
            <div class="dialogitem">
              <label>是否流量助推：</label>
              <el-select class="input" v-model="is_flow_boost" size='mini' filterable placeholder="是否流量助推" @change="orderChange($event);handleGetMediaNameOptions();" clearable>
                <el-option label="流量助推单" :value="1"></el-option>
                <el-option label="非流量助推单" :value="2"></el-option>
              </el-select>
            </div>
            <div class="dialogitem">
              <label>媒体名称：</label>
              <el-select class="input" v-model="media_name_list" size='mini' clearable filterable multiple collapse-tags placeholder="请选择媒体名称" @change="onChangeMediaNameList($event);orderChange();">
                <el-option v-for="(item,index) in mediaNameListOptions" :key="index" :label="item" :value="item" />
              </el-select>
            </div>
          </div>
          <div class="flex-between">
            <div class="dialogitem flex" style="width:100%">
              <label>申请说明：</label>
              <el-input placeholder="请输入申请说明" style="width:70%" type='textarea' v-model.trim="apply_note" size='small' clearable></el-input>
            </div>
          </div>
          <div class="flex-between">
            <div class="dialogitem flex">
              <label style="width:100px">开票金额(含税)：</label>
              <div class="input" style="width:300px">
                <span>{{invoiceTotalAmount?$formatNum(invoiceTotalAmount):'-'}}</span>
                <template v-if="orderFlag">
                  <el-button type="primary" round size='mini' style="background: #f66034;border-color: #f66034;padding:4px 8px" @click="getInvoiceTotalAmount()">刷新</el-button>
                </template>
              </div>
            </div>
          </div>
          <div v-if="orderFlag" style="font-size: 12px;
            line-height: 20px;
            color: #f66034;
            margin-left: 90px;
            margin-bottom: 10px;">（选择订单后，点击刷新，可获得所选订单后的开票金额(含税)总额）</div>
          <div class="flex-between">
            <div class="dialogitem flex">
              <label>订单：</label>
              <div class="input" style="width:100%">
                <el-button type="primary" round size='mini' @click="getOrderListByCondition()">自定义</el-button>
                （默认全部订单，如需选择部分订单，请点击自定义）
              </div>
            </div>
          </div>
          <template v-if="orderFlag">
            <ux-grid class="uxGridBox" ref="plxTable" :height="height" :checkboxConfig="{checkMethod: selectable, highlight: true}" @selection-change="selectionChange" show-footer-overflow="tooltip" show-overflow="tooltip" size="mini">
              <ux-table-column type="checkbox" align="center" fixed="left" width="40" />
              <ux-table-column v-for="item in columns" :key="item.id" :resizable="true" :field="item.prop" :title="item.label" :width="item.width" show-header-overflow='tooltip' :fixed="item.fixed" align="center">
                <template v-slot="{ row }" v-if="item.prop=='is_cash'">{{row.is_cash==1?'现金':row.is_cash==2?'授信':'-'}}</template>
              </ux-table-column>

            </ux-grid>
          </template>
        </div>
        <div style="text-align: center;margin: 20px auto 20px;">
          <el-button @click="resetCost" size="small" style="width:80px">取 消</el-button>
          <el-button type="primary" @click="setCostInvoiceEvent" size="small" style="width:80px">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { json2excel } from "@/assets/js/Export/setMethods.js"
export default {
  data () {
    return {
      addaccountFlag: false,
      deleteaccountFlag: false,
      customerList: [],
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      isEdit: false,
      customer_name: '',
      screenMonth: '',
      cost_company_name: '',
      rate: '',
      timeMonth: '',
      costCompanysList: [],
      id: '',
      costInvoiceFlag: false,
      costInvoiceInfo: {},
      cost_invoice_date: '',
      signCompanyList: [],
      company: '',
      is_cash: '',
      is_flow_boost: '',
      projectList: [],
      project_name: '',
      mediaNameListOptions: [],
      media_name_list: [],
      orderFalg: false,
      columns: [
        // { prop: 'id', filterMultiple: true, label: '订单ID', fixed: 'left', width: '110' },
        { prop: 'task_id', filterMultiple: true, label: '任务ID', fixed: 'left', width: '110' },
        { prop: 'cost_invoice_amount', filterMultiple: true, label: '开票金额', fixed: '', width: '110' },
        { prop: 'advertiser_account', filterMultiple: true, label: '账户', fixed: '', width: '110'},
        { prop: 'project_name', filterMultiple: true, label: '项目名称', fixed: '', width: '110' },
        { prop: 'month', filterMultiple: true, label: '订单月份', fixed: '', width: '110' },
        { prop: 'media_name', filterMultiple: true, label: '媒体名称', fixed: '', width: '110' },
        { prop: 'company', filterMultiple: true, label: '签约公司', fixed: '', width: '110' },
        { prop: 'cost_company_name', filterMultiple: true, label: '成本公司', fixed: '', width: '110' },
        { prop: 'is_cash', filterMultiple: true, label: '授信/现金', fixed: '', width: '80' },
        { prop: 'cost_invoice_date', filterMultiple: true, label: '成本开票日期', fixed: '', width: '110' },
      ],
      selectionList: [],
      orderFlag: false,
      height: 300,
      orderLoading: false,
      apply_note: '',
      invoiceTotalAmount: ''
    }
  },
  computed: {
    // 计算表格最大高度，确保分页控件可见
    tableMaxHeight() {
      // Header(60) + self-back(50) + padding(30) + topBox(50) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 340px
      return window.innerHeight - 260;
    }
  },
  created () {
    this.height = document.documentElement.clientHeight - 450 > 300 ? document.documentElement.clientHeight - 450 : 300
    var date = new Date();
    let month = ((date.getMonth()) <= 9 ? ('0' + (date.getMonth())) : (date.getMonth()));
    this.screenMonth = month == '00' ? ((date.getFullYear() - 1) + '-12') : (date.getFullYear() + '-' + month);
    this.costCompanys()
    this.projectListEvent()
    this.getSignCompanyList()
    this.init(1)
  },
  methods: {
    onChangeMediaNameList(val) {
      this.media_name_list = val ? [...val] : []
    },
    async handleGetMediaNameOptions() {
      this.media_name_list = []
      this.mediaNameListOptions = []

      if (this.company == '' || !this.company) {
        return
      }

      try {
        this.orderLoading = true
        const url = `${this.URL.BASEURL}${this.URL.getMediaList}`
        const params = {
          cost_company_name: this.costInvoiceInfo.cost_company_name,
          month: this.costInvoiceInfo.month,
          company: this.company,
          is_cash: this.is_cash == '' || !this.is_cash ? 0 : this.is_cash,
          project_name: this.project_name,
          is_flow_boost: !this.is_flow_boost || this.is_flow_boost == '' ? 0 : this.is_flow_boost,
        }
        const { data: res = {} } = await this.$axios.get(url, { params })
        this.orderLoading = false
        if (res && res.errno == 0) {
          this.mediaNameListOptions = res.rst;
        } else {
          this.$message.warning(res.err)
        }
      } catch (error) {
        console.log('error => ', error)
      } finally {
        this.orderLoading = false
      }
    },
    getInvoiceTotalAmount () {//开票金额（含税）
      if (this.cost_invoice_date == '' || !this.cost_invoice_date) {
        return
      }
      if (this.company == '' || !this.company) {
        return
      }
      if (this.orderFlag) {//自定义订单
        if (!this.selectionList || this.selectionList.length == 0) {
          this.$message({
            message: '请选择订单',
            type: 'fail'
          })
          return
        }
        var order_id_list = this.selectionList.map((v) => {
          return v.id
        });
      }
      this.orderLoading = true
      this.$axios.post(this.URL.BASEURL + this.URL.getInvoiceTotalAmount, {
        cost_company_name: this.costInvoiceInfo.cost_company_name,
        month: this.costInvoiceInfo.month,
        company: this.company,
        is_cash: this.is_cash == '' || !this.is_cash ? 0 : this.is_cash,
        is_flow_boost: !this.is_flow_boost || this.is_flow_boost == '' ? 0 : this.is_flow_boost,
        project_name: this.project_name,
        order_id_list: this.orderFlag ? order_id_list : [],
        media_name_list: [...this.media_name_list],
      }).then((res) => {
        var res = res.data;
        this.orderLoading = false
        if (res && res.errno == 0) {
          this.invoiceTotalAmount = res.rst;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.orderLoading = false
      })
    },
    orderChange (val) {
      if (this.cost_invoice_date == '' || !this.cost_invoice_date) {
        return
      }
      if (this.company == '' || !this.company) {
        return
      }
      this.getInvoiceTotalAmount()
      if (!this.orderFlag) {
        return
      }
      this.getOrderListByCondition()
    },
    getOrderListByCondition () {//订单列表
      if (this.cost_invoice_date == '' || !this.cost_invoice_date) {
        this.$message({
          message: '请选择开票日期',
          type: 'fail'
        })
        return
      }
      if (this.company == '' || !this.company) {
        this.$message({
          message: '请选择签约公司',
          type: 'fail'
        })
        return
      }
      this.orderFlag = true;
      this.orderLoading = true
      this.$axios.get(this.URL.BASEURL + this.URL.getOrderListByCondition, {
        params: {
          cost_company_name: this.costInvoiceInfo.cost_company_name,
          month: this.costInvoiceInfo.month,
          company: this.company,
          is_cash: this.is_cash == '' || !this.is_cash ? 0 : this.is_cash,
          is_flow_boost: !this.is_flow_boost || this.is_flow_boost == '' ? 0 : this.is_flow_boost,
          project_name: this.project_name,
          media_name_list: [...this.media_name_list],
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          var data = res.rst;
          this.datas = data
          this.$refs.plxTable.reloadData(this.datas)
          setTimeout(() => {
            this.orderLoading = false
            this.$refs.plxTable.toggleAllSelection()
          }, 1000)
        } else {
          this.orderLoading = false
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.orderLoading = false
      })
    },
    selectionChange (row) {// 选中的行
      this.selectionList = row
    },
    selectable ({ row }) {//选择表格限制条件
      return true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.resetCost()
          done();
        })
        .catch(_ => { });
    },
    projectListEvent () {
      var paramsData = {
        page: 1,
        pagesize: 9999,
      }
      this.$axios.get(this.URL.BASEURL + this.URL.projectIndex, {
        params: paramsData
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.projectList = res.rst.data;
        }
      }).catch(() => {
      })
    },
    resetCost () {
      this.costInvoiceFlag = false;
      this.costInvoiceInfo = {};
      this.cost_invoice_date = ''
      this.selectionList = [];
      this.orderFlag = false;
      this.apply_note = ''
    },
    setCostInvoice (data) {//设置成本开票日期
      this.costInvoiceFlag = true;
      this.costInvoiceInfo = data;
      this.cost_invoice_date = data.cost_invoice_date;
      this.company = data.company
    },
    setCostInvoiceEvent () {
      if (this.cost_invoice_date == '' || !this.cost_invoice_date) {
        this.$message({
          message: '请选择开票日期',
          type: 'fail'
        })
        return
      }
      if (this.company == '' || !this.company) {
        this.$message({
          message: '请选择签约公司',
          type: 'fail'
        })
        return
      }
      if (this.orderFlag) {//自定义订单
        if (!this.selectionList || this.selectionList.length == 0) {
          this.$message({
            message: '请选择订单',
            type: 'fail'
          })
          return
        }
        var order_id_list = [];
        this.selectionList.forEach((item, index) => {
          order_id_list.push(item.id)
        });
      }
      this.orderLoading = true
      this.$axios.post(this.URL.BASEURL + this.URL.setCostInvoice, {
        cost_company_name: this.costInvoiceInfo.cost_company_name,
        month: this.costInvoiceInfo.month,
        cost_invoice_date: this.cost_invoice_date,
        company: this.company,
        is_cash: this.is_cash == '' || !this.is_cash ? 0 : this.is_cash,
        is_flow_boost: !this.is_flow_boost || this.is_flow_boost == '' ? 0 : this.is_flow_boost,
        project_name: this.project_name,
        apply_type: this.orderFlag ? 2 : 1,
        order_id_list: order_id_list,
        apply_note: this.apply_note,
        media_name_list: [...this.media_name_list],
      }).then((res) => {
        var res = res.data;
        this.orderLoading = false
        if (res && res.errno == 0) {
          this.init(this.page)
          this.resetCost()
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.orderLoading = false
      })
    },
    updateEvent (data) {
      this.addaccountFlag = true;
      this.isEdit = true;
      this.cost_company_name = data.cost_company_name
      this.rate = data.rate;
      this.timeMonth = data.month;
      this.id = data.id;
    },
    costCompanys () {//成本公司全程列表
      this.$axios.get(this.URL.BASEURL + this.URL.costCompanys, {
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.costCompanysList = res.rst;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    addaccountEvent () {//点击添加账号按钮
      this.addaccountFlag = true;
      this.isEdit = false;
    },
    exportEvent () {
      this.loading = true;
      this.$axios.get(this.URL.BASEURL + this.URL.taxRate, {
        params: {
          month: this.screenMonth,
          page: 1,
          pagesize: 500,
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
           let data = res.rst.data;
           let excelDatas = [
            {
                tHeader: ['月份', '成本公司全称', '成本税点比例'],
                filterVal: ['month', 'cost_company_name', 'rate'],
                tableDatas: data,
                sheetName: '成本税点比例'
            }
           ]
           json2excel(excelDatas, '成本税点比例', true, "xlsx")
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    deleteaccountFlagEvent (data) {//删除账号
      this.$confirm('确定要删除该配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.URL.BASEURL + this.URL.delTaxRate, {
          id: data.id,
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.init(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
        })
      }).catch(() => {
      });
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    init (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.taxRate, {
        params: {
          month: this.screenMonth,
          page: page,
          pagesize: this.page_size,
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          var arr = res.rst.data;
          this.customerList = arr;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    addaccountYes () {//添加账号
      if (this.cost_company_name == '') {
        this.$message({
          message: '请输入成本公司全称',
          type: 'fail'
        })
        return
      }
      if (this.rate == '') {
        this.$message({
          message: '请输入税点比例',
          type: 'fail'
        })
        return
      }
      if (this.timeMonth == '') {
        this.$message({
          message: '请选择时间',
          type: 'fail'
        })
        return
      }
      if (this.isEdit) {//编辑
        var params = {
          cost_company_name: this.cost_company_name,
          rate: this.rate,
          month: this.timeMonth,
          id: this.id
        }
      } else {
        var params = {
          cost_company_name: this.cost_company_name,
          rate: this.rate,
          month: this.timeMonth,
        }
      }
      this.loading = true
      this.$axios.post(this.URL.BASEURL + this.URL.setTaxRate, params).then((res) => {
        var res = res.data;
        this.loading = false
        if (res && res.errno == 0) {
          this.init(this.page)
          this.cancelAddaccount()
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    cancelAddaccount () {//取消添加账号
      this.addaccountFlag = false;
      this.cost_company_name = '';
      this.rate = '';
      this.timeMonth = '';
      this.isEdit = false;
      this.id = '';
    },
    getSignCompanyList () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 1000
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.signCompanyList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
  },
  watch: {
    screenMonth () {
      this.init(1)
    },
  }
}
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
  padding: 15px 15px 15px;
  // display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: calc(100vh - 140px);
  .topBox {
    flex-shrink: 0;
  }
  .addaccountButton {
    height: 30px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 13px;
    border: none;
    padding: 0 10px;
  }
  .table {
    margin-top: 15px;
    flex: 1;
    min-height: 0;
    button {
      min-width: 48px;
      height: 22px;
      background: #5b7bfe;
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      border: none;
      padding: 0 6px;
    }
  }
  .paginationBox {
    flex-shrink: 0;
    margin-top: 15px;
    padding-bottom: 0;
  }
}
.dialogitem {
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
  label {
    display: inline-block;
    width: 110px;
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    em {
      color: red;
    }
  }
}
.topBox {
  .left {
    float: left;
  }
  .right {
    float: right;
    .lianjie {
      background: #5c7bfe;
      border: none;
      color: #ffffff;
      font-size: 12px;
      line-height: 30px;
      border-radius: 4px;
      padding: 0 8px;
      a {
        color: #ffffff;
      }
    }
  }
}
.drawer-container {
  padding: 0 10px;
  .dialogitem {
    margin: 5px;
    label {
      width: 90px;
      font-size: 12px;
      text-align: right;
    }
    .input {
      font-size: 13px;
      width: 180px;
    }
  }
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.flex {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/disposeAdmin/taxRate.vue